import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3 12.22c.6 0 1-.39 1-.977V9.287c0-1.661 1.3-2.932 3-2.932h11.6l-2.3 2.248a.93.93 0 0 0 0 1.369c.2.195.4.293.7.293s.5-.098.7-.293l4-3.91c.1-.098.2-.196.2-.294.1-.195.1-.489 0-.782-.1-.098-.1-.195-.2-.293l-4-3.91a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.368l2.3 2.248H7c-2.8 0-5 2.151-5 4.888v1.955c0 .587.4.978 1 .978m18 0c-.6 0-1 .391-1 .978v1.955c0 1.662-1.3 2.933-3 2.933H5.4l2.3-2.249a.93.93 0 0 0 0-1.368.98.98 0 0 0-1.4 0l-4 3.91c-.1.098-.2.195-.2.293-.1.196-.1.489 0 .782.1.098.1.196.2.294l4 3.91c.2.195.4.293.7.293s.5-.098.7-.293a.93.93 0 0 0 0-1.369l-2.3-2.248H17c2.8 0 5-2.15 5-4.888v-1.955c0-.587-.4-.978-1-.978"
    }, null, -1)
  ]))]))
}
export default { render: render }